<ng-container [ngSwitch]="mode" data-test="view-toolbar">
  <div class="view-toolbar" [@inOutAnimation] *ngSwitchDefault>
    <app-pillbox eventCategory="View Primary Toolbar" name="Primary Toolbar" *ngIf="(isVisible(viewUI.Pagination) || isVisible(viewUI.Mediabar))">
      <app-view-tools [collapsePagination]="collapsePagination" [mode]="viewToolsMode.Main"></app-view-tools>
    </app-pillbox>
  </div>

  <div class="view-toolbar" [@inOutAnimation] *ngSwitchCase="viewToolsMode.Media">
    <app-pillbox eventCategory="View Media Bar" [canExit]="canExit" (exit)="handleExitClick()" name="Media Bar">
      <app-view-media-bar [template]="mediaTemplate"></app-view-media-bar>
    </app-pillbox>
  </div>

  <div class="view-toolbar" [@inOutAnimation] *ngSwitchCase="viewToolsMode.Tools">
    <app-pillbox eventCategory="View Explore Tools" [canExit]="canExit" (exit)="handleExitClick()" name="Explore Tools">
      <app-view-tools [mode]="viewToolsMode.Tools"></app-view-tools>
    </app-pillbox>
  </div>

  <div class="view-toolbar" [@inOutAnimation] *ngSwitchCase="viewToolsMode.VisibilityLayers">
    <app-pillbox [canExit]="canExit" (exit)="handleExitClick()" name="Visibility Layers">
      <app-view-layers-bar></app-view-layers-bar>
    </app-pillbox>
  </div>
</ng-container>

